module.exports = __webpack_public_path__ + "img/teamwork.c3fca65c.jpg";